// extracted by mini-css-extract-plugin
export var body = "EditSupplier-module--body--DGCqy";
export var container = "EditSupplier-module--container--VuFsu";
export var footer = "EditSupplier-module--footer--Nu-jz";
export var header = "EditSupplier-module--header--EkIcj";